import { render, staticRenderFns } from "./BG.vue?vue&type=template&id=4c73b336&scoped=true&"
import script from "./BG.vue?vue&type=script&lang=js&"
export * from "./BG.vue?vue&type=script&lang=js&"
import style0 from "./BG.vue?vue&type=style&index=0&id=4c73b336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73b336",
  null
  
)

export default component.exports